/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterDefinitionCapacityReservationOptions } from './emrClusterDefinitionCapacityReservationOptions';


export interface EmrClusterDefinitionOnDemandSpecification { 
    /**
     * Specifies the strategy to use in launching On-Demand instance fleets. Currently, the only option is \"lowest-price\" (the                   default), which launches the lowest price first                
     */
    allocationStrategy?: string;
    capacityReservationOptions?: EmrClusterDefinitionCapacityReservationOptions;
}
